import { render } from "./AddOrEditOutsourcePersons.vue?vue&type=template&id=36c66f3a&scoped=true"
import script from "./AddOrEditOutsourcePersons.vue?vue&type=script&lang=js"
export * from "./AddOrEditOutsourcePersons.vue?vue&type=script&lang=js"

import "./AddOrEditOutsourcePersons.vue?vue&type=style&index=0&id=36c66f3a&scoped=true&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c66f3a"]])

export default __exports__